import React from "react";
import {createLidGeometry} from "./lidGeometry";
import {SubFloorManhole} from "./SubFloorManhole";
import {Plan, Side} from "types";

interface SubFloorLidProps {
    plan: Plan,
    scale: number,
    side: Side,
}

export const SubFloorLid: React.FC<SubFloorLidProps> = ({plan, scale, side}) => {
    const manhole =  (plan?.lid?.manholes?.length ?? 0) > 0  ? plan.lid.manholes[0] : null;
    const lidGeometry = createLidGeometry(plan, plan.lid.manholes, scale, side);

    return (
        <React.Fragment>
            {
                !!manhole
                && <SubFloorManhole plan={plan} lidGeometry={lidGeometry} manhole={manhole} scale={scale} side={side}/>
            }
        </React.Fragment>
    )
}
